import { render, staticRenderFns } from "./DetailProductInStock.vue?vue&type=template&id=0cd0cfca&scoped=true"
import script from "./DetailProductInStock.vue?vue&type=script&lang=js"
export * from "./DetailProductInStock.vue?vue&type=script&lang=js"
import style0 from "./DetailProductInStock.vue?vue&type=style&index=0&id=0cd0cfca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd0cfca",
  null
  
)

export default component.exports